// src/context/AuthContext.js
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [clientData, setClientData] = useState(null); // Optional: Store client details
  const [selectedBranch, setSelectedBranch] = useState(null); // Optional: Store admin details
  const [cartTotal, setCartTotal] = useState(0); // Optional: Store admin details
  const [loading, setLoading] = useState(true); // ✅ New
  // Check if the user is logged in on initial load
  // Check if the user is logged in on initial load
  useEffect(() => {
    const storedClientData = JSON.parse(localStorage.getItem("client"));
    const cart = JSON.parse(localStorage.getItem("cart"));
    const branchData = JSON.parse(localStorage.getItem("myBranch"));
    if (storedClientData) {
      setIsAuthenticated(true);
      setClientData(storedClientData);
    }
    if (branchData) {
      setSelectedBranch(branchData);
      // Mark that initial branch has been set
    }
    const totalitems = cart?.reduce((acc, item) => acc + item.quantity, 0);
    console.log(totalitems);
    setCartTotal(totalitems);
      setLoading(false);
  }, []);



  // Fetch notifications when `clientData` is set
  useEffect(() => {
    if (clientData) {
      authenticate(clientData);
    }
  }, [clientData]);

  // Clear authentication state and remove from localStorage
  const logout = () => {
    setIsAuthenticated(false);
    setClientData(null);
    localStorage.removeItem("client");
  };

  const authenticate = (client) => {
    if (client) {
      setIsAuthenticated(true);
      localStorage.setItem("client", JSON.stringify(client));
      return true;
    }
    return false;
  };

  const refreshClient = useCallback(async (clientId) => {
    try {
      // const client = await getClientBy(clientId);
      // localStorage.setItem('client', JSON.stringify(client));
      // setClientData(()=>client)
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        clientData,
        authenticate,
        logout,
        setClientData,
        refreshClient,
        selectedBranch,
        setSelectedBranch,
        cartTotal,
        setCartTotal,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
